const Spinner = ({ fullPage = true, size = 'normal', text = '' }) => {
  const sizeClass = size === 'large' ? 'spinner-lg' : 
                    size === 'small' ? 'spinner-sm' : 'spinner-normal';
  
  const containerClass = fullPage ? "spinner-container-full" : "spinner-container-inline";

  return (
    <div className={`spinner-overlay ${containerClass}`}>
      <div className="spinner-content">
        <div className={`themed-spinner ${sizeClass}`}>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        {text && <p className="spinner-text">{text}</p>}
      </div>
    </div>
  );
};

export default Spinner;